



$('.js-image-gallery').each( function( i, container ) {
	
	var $container = $(container);
	
	var $cbCarousel = $container.flickity({
		wrapAround: true,	 
		autoPlay: false,
		pageDots: false,
		prevNextButtons: false,
		setGallerySize: true,
		cellSelector: '.image-gallery__slide',
		cellAlign: 'center',
		lazyLoad: 1,
        draggable: false
	});
				

	var $previousButton = $container.find('.js-image-gallery-prev');
	
	$previousButton.on('click', function() {
		$cbCarousel.flickity('previous');
	});
	
	var $nextButton = $container.find('.js-image-gallery-next');
	
	$nextButton.on('click', function() {
		$cbCarousel.flickity('next');
	});


});




